module.exports = __webpack_public_path__ + "static/media/cd2-icon-license.b73fa495.svg";